import { dialogDefault, OPEN_DIALOG_SCLERALCLIENT, CLOSE_DIALOG_SCLERALCLIENT } from "../consts";

const mydialog = { ...dialogDefault };

export const openDialogScleralClient = (id, clientId) => ({ type: OPEN_DIALOG_SCLERALCLIENT, payload: { open: true, id, clientId } });
export const closeDialogScleralClient = () => ({ type: CLOSE_DIALOG_SCLERALCLIENT, payload: { open: false, id:0, clientId:0 } });


export default function scleralsClientDialogReducer(state = mydialog, { type, payload }) {
    const actions = {
        [OPEN_DIALOG_SCLERALCLIENT] : () => ({...state, ...payload }),
        [CLOSE_DIALOG_SCLERALCLIENT] : () => ({...state, ...payload }),
    }

    return actions[type]?.call() || state;
}

